import { render } from "./VxEditPost.vue?vue&type=template&id=5113e258"
import script from "./VxEditPost.vue?vue&type=script&lang=js"
export * from "./VxEditPost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__